import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class VendorResource extends BaseResource {
    pk() {
        return this.customerId.toString();
    }
}
VendorResource.urlRoot = apiResourceUrl("vendors");
//# sourceMappingURL=VendorResource.js.map